// src/components/TransactionModal.jsx

import React, {
  useState,
  useEffect,
} from "react";

import "../css/transactionModal.css";
import logo from "../assets/logo.png";
import {
  X,
  User,
  CreditCard,
  Wallet,
  Truck,
  Star,
  Receipt,
  BadgeDollarSign,
  AlertTriangle,
  CheckCircle2,
Loader2,
XCircle,
} from "lucide-react";


import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CalendarDays } from "lucide-react";


const routes = [
  "WAK-PAR",
  "PAR-WAK",
  "PAR-LEG",
  "LEG-PAR",
  "PAR-SUP",
  "SUP-PAR",
];

const vehicles = [
  "CAR",
  "MINIBUS",
  "CANTER 16FT",
  "CANTER 19FT",
  "CANTER 22 FT",
  "PICKUP",
  "SINGLE AXEL TRUCK",
  "DOUBLE AXEL TRUCK",
  "EXCAVATOR",
];

const TransactionModal = ({
  isOpen,
  onClose,

  cart,
  setCart,

  selectedCustomer,
  setSelectedCustomer,

  selectedSender,
  setSelectedSender,

  paymentMethod,
  setPaymentMethod,

  amountTendered,
  setAmountTendered,

  availablePoints,

  usePoints,
  setUsePoints,

  pointsToRedeem,
  setPointsToRedeem,

  ferryDetails,
  setFerryDetails,

  receiverInfo,
  setReceiverInfo,

  customerDatabase,

  onFinish,

  cartRequiresTwoCustomers,

  onIncQty,
  onDecQty,
  onSetQty,
}) => {

  /* =====================================================
      LOCAL SEARCH STATES
  ===================================================== */

  const [search, setSearch] =
    useState("");

  const [
    filteredCustomers,
    setFilteredCustomers,
  ] = useState([]);

  const [
    senderSearch,
    setSenderSearch,
  ] = useState("");

  const [
    filteredSenders,
    setFilteredSenders,
  ] = useState([]);

  const [
  validationMessage,
  setValidationMessage,
  ] = useState("");

useEffect(() => {

  if (!validationMessage) return;

  const timer =
    setTimeout(() => {

      setValidationMessage("");

    }, 3500);

  return () =>
    clearTimeout(timer);

}, [validationMessage]);


const [
transactionLoading,
setTransactionLoading,
] = useState(false);

const [
transactionSuccess,
setTransactionSuccess,
] = useState(false);

const [
transactionFailed,
setTransactionFailed,
] = useState(false);


const [
  detailsLocked,
  setDetailsLocked,
] = useState(false);

const [
    customerVehicles,
    setCustomerVehicles
] = useState([]);

const [
    showVehiclePicker,
    setShowVehiclePicker
] = useState(false);

const [
    loadingVehicles,
    setLoadingVehicles
] = useState(false);

const [
    singleVehicle,
    setSingleVehicle
] = useState(null);

const [
    singleVehicleFound,
    setSingleVehicleFound
] = useState(false);

  /* =====================================================
      CUSTOMER SEARCH
  ===================================================== */

  useEffect(() => {

    if (search) {

      const filtered =
        customerDatabase.filter(
          (c) =>
            c.name
              .toLowerCase()
              .includes(
                search.toLowerCase()
              ) &&
            c.status === "active"
        );

      setFilteredCustomers(
        filtered
      );

    } else {

      setFilteredCustomers([]);

    }

  }, [search, customerDatabase]);

  const formatPlainDate = (
  value
) => {

  if (!value) return "-";

  const [
    year,
    month,
    day,
  ] = value.split("-");

  return `${day}/${month}/${year}`;
};

  /* =====================================================
      SENDER SEARCH
  ===================================================== */

  useEffect(() => {

    if (senderSearch) {

      const filtered =
        customerDatabase.filter(
          (c) =>
            c.name
              .toLowerCase()
              .includes(
                senderSearch.toLowerCase()
              ) &&
            c.status === "active"
        );

      setFilteredSenders(
        filtered
      );

    } else {

      setFilteredSenders([]);

    }

  }, [
    senderSearch,
    customerDatabase,
  ]);


  /* =====================================================
      CUSTOMER SELECT
  ===================================================== */

  const handleSelectCustomer = (
    customer
  ) => {

    setSelectedCustomer({
      id: customer.id,
      external_id:
        customer.external_id,
      name: customer.name,
      phone: customer.phone,
      address:
        customer.address,
      status: customer.status,
      customer_type:
        customer.customer_type,
    });

setSearch("");

setFilteredCustomers([]);

fetchCustomerVehicles(customer);
  };




const fetchCustomerVehicles = async (customer) => {

console.log(
    "API BASE:",
    process.env.REACT_APP_API_BASE
);

    if (!hasFerryPass) return;

    if (!customer?.external_id) return;

    try {

        setLoadingVehicles(true);

        const token =
            localStorage.getItem("token");

        const response = await fetch(

            `${process.env.REACT_APP_API_BASE}/ferry/frequent-travelers/customer/${customer.external_id}`,

            {

                headers: {

                    Authorization: `Bearer ${token}`

                }

            }

        );

        if (!response.ok) {

            throw new Error(
                "Unable to load saved vehicles."
            );

        }

        const data =
            await response.json();



        if (!Array.isArray(data) || data.length === 0) {

            setCustomerVehicles([]);
            setShowVehiclePicker(false);

            return;

        }

        /* ==========================================
           ONE SAVED VEHICLE
        ========================================== */
if (data.length === 1) {

    setSingleVehicle(data[0]);

    setSingleVehicleFound(true);

    return;

}

        /* ==========================================
           MULTIPLE SAVED VEHICLES
        ========================================== */

        setCustomerVehicles(data);

        setShowVehiclePicker(true);

    }

    catch (err) {

        console.error(err);

        setCustomerVehicles([]);

        setShowVehiclePicker(false);

    }

    finally {

        setLoadingVehicles(false);

    }

};

  /* =====================================================
      SENDER SELECT
  ===================================================== */

  const handleSelectSender = (
    customer
  ) => {

    setSelectedSender(customer);

    setSenderSearch("");

    setFilteredSenders([]);
  };


  /* =====================================================
      CONDITIONS
  ===================================================== */

  const hasFerryPass =
    cart.some(
      (item) => item.id === 8
    );

const subtotal = cart.reduce((sum, item) => {

  if (item.exclude_from_total)
    return sum;

  return (
    sum +
    item.price *
      item.quantity
  );

}, 0);



const commission = cart.reduce((sum, item) => {

  if (!item.is_commission)
    return sum;

  return (
    sum +
    item.price *
      item.quantity
  );

}, 0);


const discount =
  cart.reduce((sum, item) => {

    if (item.exclude_from_total)
      return sum;

      if (
        !item.discount ||
        isNaN(item.discount)
      ) {
        return sum;
      }

      if (
        item.discountType ===
        "percent"
      ) {

        return (
          sum +
          (
            item.price *
            item.quantity
          ) *
          (
            item.discount /
            100
          )
        );
      }

      if (
        item.discountType ===
        "cash"
      ) {

        return (
          sum +
          parseFloat(
            item.discount
          )
        );
      }

      return sum;

    }, 0);

  const total =
    subtotal - discount;

  const amountDue =
    Math.max(
      total -
        (
          usePoints
            ? pointsToRedeem * 2
            : 0
        ),
      0
    );

  const change =
    paymentMethod === "Cash"
      ? (
          parseFloat(
            amountTendered || 0
          ) - amountDue
        )
      : 0;


const validateTransaction = () => {

  setValidationMessage("");

  /* =====================================================
      PAYMENT METHOD
  ===================================================== */

  if (!paymentMethod) {

    setValidationMessage(
      "Select a payment method before processing."
    );

    return false;
  }

  /* =====================================================
      CREDIT CUSTOMER
  ===================================================== */

  if (
    paymentMethod === "Credit" &&
    !cartRequiresTwoCustomers &&
    !selectedCustomer
  ) {

    setValidationMessage(
      "Customer required for Credit transactions."
    );

    return false;
  }

  /* =====================================================
      MMG VALIDATION
  ===================================================== */

  if (cartRequiresTwoCustomers) {

    if (!selectedSender) {

      setValidationMessage(
        "Sender is required."
      );

      return false;
    }

    if (
      !receiverInfo.name ||
      !receiverInfo.trans_id ||
      !receiverInfo.acc_number
    ) {

      setValidationMessage(
        "Complete receiver information."
      );

      return false;
    }
  }

  /* =====================================================
      FERRY VALIDATION
  ===================================================== */

  if (hasFerryPass) {

    if (
      !ferryDetails.vehicle_no ||
      !ferryDetails.booking ||
      !ferryDetails.payment ||
      !ferryDetails.vehicle_type ||
      !ferryDetails.route
    ) {

      setValidationMessage(
        "Complete FerryPass information."
      );

      return false;
    }

    if (
      ferryDetails.roundTrip &&
      !ferryDetails.returnDate
    ) {

      setValidationMessage(
        "Select return trip date."
      );

      return false;
    }
  }

  /* =====================================================
      CASH VALIDATION
  ===================================================== */

  if (
    paymentMethod === "Cash"
  ) {

    if (
      !amountTendered ||
      parseFloat(amountTendered) <
      amountDue
    ) {

      setValidationMessage(
        "Insufficient cash amount."
      );

      return false;
    }
  }

  return true;
};


useEffect(() => {

const handleKeyPress = (
  e
) => {

const isProcessKey =
  e.key === "+" ||
  e.key === "=" ||
  e.code === "NumpadAdd" ||
  (
    e.key === "Enter" &&
    !document.querySelector(
      ".modern-price-modal"
    )
  );

  if (!isProcessKey) return;

  e.preventDefault();

  const valid =
    validateTransaction();

  if (!valid) {
    return;
  }

  processTransaction();
};

  window.addEventListener(
    "keydown",
    handleKeyPress
  );

  return () =>
    window.removeEventListener(
      "keydown",
      handleKeyPress
    );

}, [
  paymentMethod,
  selectedCustomer,
  selectedSender,
  receiverInfo,
  ferryDetails,
  amountTendered,
  amountDue,
  cart,
  validationMessage,
]);


const processTransaction =
  async () => {

  const valid =
    validateTransaction();

  if (!valid) return;

  try {

    /* =====================================================
        START LOADER
    ===================================================== */

    setTransactionLoading(true);

    /* =====================================================
        LOADER → SUCCESS
    ===================================================== */

    setTimeout(() => {

      setTransactionLoading(false);

      setTransactionSuccess(true);

    }, 1400);

    /* =====================================================
        SUCCESS → RECEIPT
    ===================================================== */

    setTimeout(async () => {

      setTransactionSuccess(false);

      await onFinish();

      onClose();

    }, 3600);

  } catch (err) {

    console.error(err);

    setTransactionLoading(false);

    setTransactionSuccess(false);

    setTransactionFailed(true);

    setTimeout(() => {

      setTransactionFailed(false);

    }, 2200);
  }
};

  /* =====================================================
      EARLY RETURN
  ===================================================== */

  if (!isOpen) return null;



  return (

    <div className="transaction-modal-overlay">

      <div className="transaction-modal-container">



{validationMessage && (

  <div className="transaction-popup-alert">

    <div className="transaction-popup-icon">

      <AlertTriangle
        size={18}
      />

    </div>

    <div className="transaction-popup-content">

      <strong>
        Transaction Warning
      </strong>

      <span>
        {validationMessage}
      </span>

    </div>

  </div>

)}

{transactionLoading && (

  <div className="transaction-status-overlay">

    <div className="transaction-status-card">

      <div className="transaction-loader-ring">

        <img
          src={logo}
          alt="RCS"
          className="transaction-loader-logo"
        />

      </div>

      <h2>
        Processing Transaction
      </h2>

      <p>
        Hang tight, Your Transaction is being processed!
      </p>

    </div>

  </div>

)}


{transactionSuccess && (

  <div className="transaction-status-overlay">

    <div className="transaction-status-card success">

      <div className="transaction-status-icon success">

        <CheckCircle2
          size={44}
        />

      </div>

      <h2>
        Transaction Complete
      </h2>

      <p>
        Sale recorded
        successfully.
      </p>

    </div>

  </div>

)}

{transactionFailed && (

  <div className="transaction-status-overlay">

    <div className="transaction-status-card failed">

      <div className="transaction-status-icon failed">

        <XCircle
          size={44}
        />

      </div>

      <h2>
        Transaction Failed
      </h2>

      <p>
        Unable to process
        transaction.
      </p>

    </div>

  </div>

)}


        {/* =====================================================
            HEADER
        ===================================================== */}
        <div className="transaction-modal-header">

          <div>

            <span className="transaction-pill">
              RCS POS
            </span>

            <h2>
              Transaction Terminal
            </h2>

            <p>
              Complete and review
              the transaction before proceeding!
            </p>
          </div>

<div className="transaction-header-actions">

  <button
    className={`transaction-lock-btn ${
      detailsLocked
        ? "locked"
        : ""
    }`}

    onClick={() =>
      setDetailsLocked(
        !detailsLocked
      )
    }
  >

    {detailsLocked
      ? "🔒 Locked"
      : "🔓 Lock Details"}

  </button>

  <button
    className="transaction-close-btn"
    onClick={onClose}
  >

    <X size={20} />

  </button>

</div>

        </div>

        {/* =====================================================
            BODY
        ===================================================== */}
        <div className="transaction-modal-body">

          {/* =====================================================
              LEFT PANEL
          ===================================================== */}
          <div className="transaction-left-panel">

            {/* =====================================================
                CUSTOMER
            ===================================================== */}
            <div className="transaction-card">

              <div className="transaction-card-header">

                <User size={18} />

                <h3>
                  Customer
                </h3>

              </div>

              {!cartRequiresTwoCustomers ? (

                <div className="transaction-section-body">

                  <input
                    type="text"
                    placeholder="Search customer..."
                    value={search}
                    onChange={(e) =>
                      setSearch(
                        e.target.value
                      )
                    }
                    className="transaction-input"
                  />

                  {filteredCustomers.length >
                    0 && (

                    <div className="transaction-customer-dropdown">

                      {filteredCustomers.map(
                        (
                          customer
                        ) => (

                          <button
                            key={
                              customer.id
                            }
                            className="transaction-customer-item"
                            onClick={() =>
                              handleSelectCustomer(
                                customer
                              )
                            }
                          >

                            {
                              customer.name
                            }

                          </button>

                        )
                      )}

                    </div>

                  )}

                  {selectedCustomer && (

                    <div className="transaction-selected-customer">

                      <strong>
                        {
                          selectedCustomer.name
                        }
                      </strong>

                      <span>
                        {
                          selectedCustomer.phone
                        }
                      </span>

                    </div>

                  )}

                  {paymentMethod ===
                    "Credit" &&
                    !selectedCustomer && (

                    <div className="transaction-warning">

                      Customer is
                      required for
                      Credit sales.

                    </div>

                  )}

                </div>

              ) : (

                <div className="transaction-two-column">

                  {/* =====================================================
                      SENDER
                  ===================================================== */}
                  <div>

                    <label>
                      Sender
                    </label>

                    <input
                      type="text"
                      placeholder="Search sender..."
                      value={
                        senderSearch
                      }
                      onChange={(e) =>
                        setSenderSearch(
                          e.target.value
                        )
                      }
                      className="transaction-input"
                    />

                    {filteredSenders.length >
                      0 && (

                      <div className="transaction-customer-dropdown">

                        {filteredSenders.map(
                          (
                            customer
                          ) => (

                            <button
                              key={
                                customer.id
                              }
                              className="transaction-customer-item"
                              onClick={() =>
                                handleSelectSender(
                                  customer
                                )
                              }
                            >

                              {
                                customer.name
                              }

                            </button>

                          )
                        )}

                      </div>

                    )}

                    {selectedSender && (

                      <div className="transaction-selected-customer">

                        <strong>
                          {
                            selectedSender.name
                          }
                        </strong>

                        <span>
                          {
                            selectedSender.phone
                          }
                        </span>

                      </div>

                    )}

                  </div>

                  {/* =====================================================
                      RECEIVER
                  ===================================================== */}
                  <div>

                    <label>
                      Receiver
                    </label>

                    <input
                      type="text"
                      placeholder="Receiver Name"

                       disabled={detailsLocked}
                      value={
                        receiverInfo.name
                      }
                      onChange={(e) =>
                        setReceiverInfo({
                          ...receiverInfo,
                          name:
                            e.target.value,
                        })
                      }
                      className="transaction-input"
                    />

                    <input
                      type="text"
                      placeholder="Transaction ID"

                       disabled={detailsLocked}
                      value={
                        receiverInfo.trans_id
                      }
                      onChange={(e) =>
                        setReceiverInfo({
                          ...receiverInfo,
                          trans_id:
                            e.target.value,
                        })
                      }
                      className="transaction-input"
                    />

                    <input
                      type="text"
                      placeholder="Account Number"

                       disabled={detailsLocked}
                      value={
                        receiverInfo.acc_number
                      }
                      onChange={(e) =>
                        setReceiverInfo({
                          ...receiverInfo,
                          acc_number:
                            e.target.value,
                        })
                      }
                      className="transaction-input"
                    />

                  </div>

                </div>

              )}

            </div>

            {/* =====================================================
                CART
            ===================================================== */}
            <div className="transaction-card">

              <div className="transaction-card-header">

                <Receipt size={18} />

                <h3>
                  Cart Review
                </h3>

              </div>

              <div className="transaction-cart-list">

{cart
  .filter(item => !item.exclude_from_total)
  .map((item,index)=>(

                    <div
                      key={index}
                      className="transaction-cart-item"
                    >

                      <div>

                        <strong>
                          {item.name}
                        </strong>

                        <span>
                          $
                          {item.price.toFixed(
                            2
                          )}
                        </span>

                      </div>

                      <div className="transaction-qty-controls">

                        <button
                          onClick={() =>
                            onDecQty(index)
                          }
                        >
                          -
                        </button>

                        <span>
                          {
                            item.quantity
                          }
                        </span>

                        <button
                          onClick={() =>
                            onIncQty(index)
                          }
                        >
                          +
                        </button>

                      </div>

                    </div>

                  )
                )}

              </div>

            </div>

            {/* =====================================================
                FERRY
            ===================================================== */}
            <div className={`transaction-card ${
              !hasFerryPass
                ? "disabled"
                : ""
            }`}>

              <div className="transaction-card-header">

                <Truck size={18} />

                <h3>
                  Ferry Booking
                </h3>

              </div>

              {!hasFerryPass ? (

                <p className="transaction-disabled-text">

                  Add FerryPass to
                  enable this
                  section.

                </p>

              ) : (

                <div className="transaction-section-body">

                  <input
                    type="text"
                    placeholder="Vehicle Number"

                     disabled={detailsLocked}
                    value={
                      ferryDetails.vehicle_no
                    }
                    onChange={(e) =>
                      setFerryDetails({
                        ...ferryDetails,
                        vehicle_no:
                          e.target.value,
                      })
                    }
                    className="transaction-input"
                  />

                  <input
                    type="text"
                    placeholder="Booking Number"

                     disabled={detailsLocked}
                    value={
                      ferryDetails.booking
                    }
                    onChange={(e) =>
                      setFerryDetails({
                        ...ferryDetails,
                        booking:
                          e.target.value,
                      })
                    }
                    className="transaction-input"
                  />

                  <input
                    type="text"
                    placeholder="Payment Number"

                     disabled={detailsLocked}
                    value={
                      ferryDetails.payment
                    }
                    onChange={(e) =>
                      setFerryDetails({
                        ...ferryDetails,
                        payment:
                          e.target.value,
                      })
                    }
                    className="transaction-input"
                  />

                  <select
                    value={
                      ferryDetails.vehicle_type
                    }
                    onChange={(e) =>
                      setFerryDetails({
                        ...ferryDetails,
                        vehicle_type:
                          e.target.value,
                      })
                    }
                    className="transaction-input"
                  >

                    <option value="">
                      Vehicle Type
                    </option>

                    {vehicles.map(
                      (v) => (

                        <option
                          key={v}
                          value={v}
                        >
                          {v}
                        </option>

                      )
                    )}

                  </select>

                  <select
                    value={
                      ferryDetails.route
                    }
                    onChange={(e) =>
                      setFerryDetails({
                        ...ferryDetails,
                        route:
                          e.target.value,
                      })
                    }
                    className="transaction-input"
                  >

                    <option value="">
                      Select Route
                    </option>

                    {routes.map(
                      (r) => (

                        <option
                          key={r}
                          value={r}
                        >
                          {r}
                        </option>

                      )
                    )}

                  </select>
<div className="transaction-date-picker">

  <CalendarDays size={18} />

  <DatePicker
    selected={
      ferryDetails.travelDate
        ? new Date(ferryDetails.travelDate + "T12:00:00")
        : null
    }
    onChange={(date) => {

      if (!date) {
        setFerryDetails({
          ...ferryDetails,
          travelDate: "",
        });
        return;
      }

      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");

      setFerryDetails({
        ...ferryDetails,
        travelDate: `${yyyy}-${mm}-${dd}`,
      });

    }}
    dateFormat="dd/MM/yyyy"
    minDate={new Date()}
    placeholderText="Travel Date"
    className="transaction-input"
/>

</div>

<div className="transaction-roundtrip-row">

  <label>
    Round Trip
  </label>

<label className="transaction-switch">

    <input
        type="checkbox"
        checked={ferryDetails.roundTrip}
        onChange={(e)=>
            setFerryDetails({
                ...ferryDetails,
                roundTrip:e.target.checked
            })
        }
    />

    <span className="transaction-slider"></span>

</label>

</div>

{ferryDetails.roundTrip && (

<div className="transaction-date-picker">

    <CalendarDays size={18}/>

    <DatePicker

        selected={
            ferryDetails.returnDate
                ? new Date(
                    ferryDetails.returnDate + "T12:00:00"
                  )
                : null
        }

        onChange={(date)=>{

            if(!date){

                setFerryDetails({
                    ...ferryDetails,
                    returnDate:""
                });

                return;
            }

            const yyyy=date.getFullYear();
            const mm=String(date.getMonth()+1).padStart(2,"0");
            const dd=String(date.getDate()).padStart(2,"0");

            setFerryDetails({
                ...ferryDetails,
                returnDate:`${yyyy}-${mm}-${dd}`
            });

        }}

        dateFormat="dd/MM/yyyy"

        minDate={
            ferryDetails.travelDate
                ? new Date(
                    ferryDetails.travelDate + "T12:00:00"
                  )
                : new Date()
        }

        placeholderText="Return Date"

        className="transaction-input"

    />

</div>

)}

                </div>

              )}

            </div>

            {/* =====================================================
                PAYMENT METHOD
            ===================================================== */}
            <div className="transaction-card">

              <div className="transaction-card-header">

                <CreditCard size={18} />

                <h3>
                  Payment Method
                </h3>

              </div>

              <div className="transaction-method-grid">

                <button
                  className={
                    paymentMethod ===
                    "Cash"
                      ? "active"
                      : ""
                  }
                  onClick={() =>
                    setPaymentMethod(
                      "Cash"
                    )
                  }
                >

                  Cash

                </button>

                <button
                  className={
                    paymentMethod ===
                    "Credit"
                      ? "active"
                      : ""
                  }
                  onClick={() =>
                    setPaymentMethod(
                      "Credit"
                    )
                  }
                >

                  Credit

                </button>

              </div>

            </div>

            {/* =====================================================
                CASH TENDER
            ===================================================== */}
            {paymentMethod ===
              "Cash" && (

              <div className="transaction-card">

                <div className="transaction-card-header">

                  <Wallet size={18} />

                  <h3>
                    Cash Tendered
                  </h3>

                </div>

                <input
                  type="number"
                  placeholder="Enter amount tendered"
                  value={
                    amountTendered
                  }
                  onChange={(e) =>
                    setAmountTendered(
                      e.target.value
                    )
                  }
                  className="transaction-input"
                />

              </div>

            )}

            {/* =====================================================
                LOYALTY
            ===================================================== */}
            {availablePoints >
              0 && (

              <div className="transaction-card">

                <div className="transaction-card-header">

                  <Star size={18} />

                  <h3>
                    Loyalty Points
                  </h3>

                </div>

                <div className="transaction-loyalty-box">

                  <div>

                    <strong>
                      {
                        availablePoints
                      }
                      {" "}
                      points
                    </strong>

                    <p>
                      Available for
                      redemption
                    </p>

                  </div>

                  <input
                    type="checkbox"
                    checked={
                      usePoints
                    }
                    onChange={(e) =>
                      setUsePoints(
                        e.target.checked
                      )
                    }
                  />

                </div>

              </div>

            )}


            {/* =====================================================
                FINISH
            ===================================================== */}
<button
  className="transaction-finish-btn"
  onClick={
    processTransaction
  }
>

  <BadgeDollarSign
    size={18}
  />

  Finish Transaction

</button>

          </div>

          {/* =====================================================
              RIGHT PANEL
          ===================================================== */}
          <div className="transaction-right-panel">

            <div className="transaction-preview-card">

              <h3>
                Live Receipt
              </h3>

              <div className="transaction-preview-items">

                {cart.map(
                  (
                    item,
                    index
                  ) => (

                    <div
                      key={index}
                      className="transaction-preview-row"
                    >

                      <span>
                        {item.quantity}x
                        {" "}
                        {item.name}
                      </span>

                      <strong>
                        $
                        {(
                          item.price *
                          item.quantity
                        ).toFixed(2)}
                      </strong>

                    </div>

                  )
                )}

<div className="transaction-preview-info-card">

  <h4>
    Customer Information
  </h4>

  {cartRequiresTwoCustomers ? (

    <>

      <div className="transaction-preview-info-row">

        <span>
          Sender
        </span>

        <strong>
          {selectedSender?.name || "-"}
        </strong>

      </div>

      <div className="transaction-preview-info-row">

        <span>
          Receiver
        </span>

        <strong>
          {receiverInfo.name || "-"}
        </strong>

      </div>

      <div className="transaction-preview-info-row">

        <span>
          Transaction ID
        </span>

        <strong>
          {receiverInfo.trans_id || "-"}
        </strong>

      </div>

      <div className="transaction-preview-info-row">

        <span>
          Account Number
        </span>

        <strong>
          {receiverInfo.acc_number || "-"}
        </strong>

      </div>

    </>

  ) : (

    <>

      <div className="transaction-preview-info-row">

        <span>
          Customer
        </span>

        <strong>
          {selectedCustomer?.name || "Unknown"}
        </strong>

      </div>

      <div className="transaction-preview-info-row">

        <span>
          Phone
        </span>

        <strong>
          {selectedCustomer?.phone || "-"}
        </strong>

      </div>

    </>

  )}

</div>

{hasFerryPass && (

  <div className="transaction-preview-info-card">

    <h4>
      Ferry Information
    </h4>

    <div className="transaction-preview-info-row">

      <span>
        Vehicle No
      </span>

      <strong>
        {ferryDetails.vehicle_no || "-"}
      </strong>

    </div>

    <div className="transaction-preview-info-row">

      <span>
        Vehicle Type
      </span>

      <strong>
        {ferryDetails.vehicle_type || "-"}
      </strong>

    </div>

    <div className="transaction-preview-info-row">

      <span>
        Route
      </span>

      <strong>
        {ferryDetails.route || "-"}
      </strong>

    </div>

    <div className="transaction-preview-info-row">

      <span>
        Booking
      </span>

      <strong>
        {ferryDetails.booking || "-"}
      </strong>

    </div>

<div className="transaction-preview-info-row">

  <span>
    Travel Date
  </span>

  <strong>
    {ferryDetails.travelDate || "-"}
  </strong>

</div>

{ferryDetails.roundTrip && (

  <div className="transaction-preview-info-row">

    <span>
      Return Date
    </span>

    <strong>
      {ferryDetails.returnDate || "-"}
    </strong>

  </div>

)}
  </div>

)}


              </div>

              <div className="transaction-preview-summary">

                <div className="transaction-preview-row">

                  <span>
                    Subtotal
                  </span>

                  <strong>
                    $
                    {subtotal.toFixed(
                      2
                    )}
                  </strong>

                </div>

                <div className="transaction-preview-row">

                  <span>
                    Discount
                  </span>

                  <strong>
                    -$
                    {discount.toFixed(
                      2
                    )}
                  </strong>

                </div>


{commission > 0 && (

  <div className="transaction-preview-row commission">

    <span>
      Commission Earned
    </span>

    <strong
      style={{ color: "#16a34a" }}
    >
      +$
      {commission.toFixed(2)}
    </strong>

  </div>

)}

                <div className="transaction-preview-row total">

                  <span>
                    Amount Due
                  </span>

                  <strong>
                    $
                    {amountDue.toFixed(
                      2
                    )}
                  </strong>

                </div>

                {paymentMethod ===
                  "Cash" && (

                  <div className="transaction-preview-row change">

                    <span>
                      Change
                    </span>

                    <strong>
                      $
                      {change.toFixed(
                        2
                      )}
                    </strong>

                  </div>

                )}

              </div>

            </div>

          </div>

{singleVehicleFound && singleVehicle && (

<div className="transaction-status-overlay">

    <div className="transaction-single-vehicle-card">

        <div className="transaction-single-vehicle-icon">

            <AlertTriangle size={42}/>

        </div>

        <h2>

            Saved Vehicle Found

        </h2>

        <p>

            This customer has a saved vehicle on file.

            Would you like to use it to automatically complete the vehicle information?

        </p>

        <div className="transaction-single-vehicle-preview">

            <strong>

                {singleVehicle.vehicle_number}

            </strong>

            <span>

                {singleVehicle.vehicle_type}

            </span>

        </div>

        <div className="transaction-single-actions">

            <button

                className="transaction-single-confirm"

                onClick={()=>{

                    setFerryDetails(prev=>({

                        ...prev,

                        vehicle_no:
                            singleVehicle.vehicle_number,

                        vehicle_type:
                            singleVehicle.vehicle_type

                    }));

                    setSingleVehicleFound(false);

                    setSingleVehicle(null);

                }}

            >

                Use Saved Vehicle

            </button>

            <button

                className="transaction-single-cancel"

                onClick={()=>{

                    setSingleVehicleFound(false);

                    setSingleVehicle(null);

                }}

            >

                Enter Manually

            </button>

        </div>

    </div>

</div>

)}

{showVehiclePicker && (

<div className="transaction-status-overlay">

<div className="transaction-vehicle-picker">

<div className="transaction-vehicle-picker-header">

<h2>

Saved Vehicles

</h2>

<p>

Select one of the customer's saved vehicles.

</p>

</div>

<div className="transaction-vehicle-list">

{customerVehicles.map(vehicle=>(

<div

key={vehicle.id}

className="transaction-vehicle-card"

onClick={()=>{

setFerryDetails({

...ferryDetails,

vehicle_no:vehicle.vehicle_number,

vehicle_type:vehicle.vehicle_type

});

setShowVehiclePicker(false);

}}

>

<div>

<strong>

{vehicle.vehicle_number}

</strong>

<span>

{vehicle.vehicle_type}

</span>

</div>

<button>

Use

</button>

</div>

))}

</div>

<button

className="transaction-skip-btn"

onClick={()=>setShowVehiclePicker(false)}

>

Continue Manually

</button>

</div>

</div>

)}

        </div>

      </div>

    </div>

  );
};

export default TransactionModal;